// API END Points
import * as constants from "../utils/constants";
/**---------------Authentication------------------------------ */
export const AddFeedback = "/default/contact-us" + " " + constants.POST_RAW;
export const FAQ = "/admin/faqList" + " " + constants.GET_URL_PARAMS;
export const TNC = "/default/terms-conditions" + " " + constants.GET_URL_PARAMS;
export const Policy = "/default/privacy-policy" + " " + constants.GET_URL_PARAMS;
